import script from "./gamePlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./gamePlayer.vue?vue&type=script&setup=true&lang=ts"

import "./gamePlayer.vue?vue&type=style&index=0&id=0e28ea52&lang=css"

const __exports__ = script;

export default __exports__